export const CODELESS_CONVERSION_TYPE_OPTIONS = {
    BUTTON_CLICKS: 'Button Clicks',
    URL_VISITS: 'URL Visits',
};
